{
    "RTE_Label": "Iniziare a digitare...",
    "NAME": "RichTextEditor"
}